import {Badge} from './badge.component'
import {defineWebComponent} from "../webcomponents-utils";

export * from './badge.component';

export default Badge;

defineWebComponent('wl-badge', Badge);